// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"94":"098243a5","605":"629867cb","809":"62452d41","981":"9f875a43"}[chunkId] + ".chunk.js";
};